import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';

import { App } from './App';
import { MyProvider } from "./State/ProviderData";

// CSS
import 'bulma/css/bulma.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'leaflet/dist/leaflet.css';
import './styles/styles.less';
import './styles/custom.scss';

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <MyProvider>
        <App />
      </MyProvider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);


// import React from 'react';
// import ReactDOM from 'react-dom';
// import { App } from './App';
// import 'bulma/css/bulma.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle';
// import 'leaflet/dist/leaflet.css';
// //import './xltri.css';
// import './styles/styles.less';
// import './styles/custom.scss'
// import { MyProvider } from "./State/ProviderData";



// ReactDOM.render(<MyProvider><App /></MyProvider>, document.getElementById('root'));
